<div class="bid-box-grid pb-4" [class.large]="isLarge()">
  @for (
    auction of memorabidAuctions()
        | slice
          : 0
          : (isSearchPage()
              ? auctionDownloadedService.memorabidAuctionSliceEnd
              : showCardsNumber());
      track auction.idAuction
  ) {
  <app-bid-element
    [idEvent]="idEvent()"
    [slug]="slug()"
    [auction]="auction"
    [isHomepageEvidence]="isHomepage() && auction.evidenceLevel == 3"
  />
  }

  @for (auction of marketplaceAuctions()
        | slice
          : 0
          : (isSearchPage()
              ? auctionDownloadedService.marketplaceAuctionSliceEnd
              : startingAuctionNumber());
      track auction.idAuction){
    <app-bid-element [auction]="auction" />
  }
</div>

@if(
  showMoreText() != ''
  && (
    !!showMoreRoute()
    || (
      memorabidAuctionsLength() > auctionDownloadedService.memorabidAuctionSliceEnd
      || marketplaceAuctionsLength() > auctionDownloadedService.marketplaceAuctionSliceEnd
    )
  )
){
<div class="d-flex justify-content-center pb-4">
  <button
    type="button"
    class="text-uppercase fw-bold px-3"
    (eventTracker)="({ category: 'user', action: 'click' })"
    [class.btn-gold]="isMemorabidBox() || !isMarketplaceBox()"
    [class.btn-marketplace]="isMarketplaceBox()"
    (click)="onShowMoreClick()"
  >
    {{ showMoreText() | translate }}
    {{
      showRemainingAuctionNumber()
        ? "(" +
          ((isMemorabidBox()
            ? memorabidAuctionsLength()
            : marketplaceAuctionsLength()) -
            (isMemorabidBox()
              ? auctionDownloadedService.memorabidAuctionSliceEnd
              : auctionDownloadedService.marketplaceAuctionSliceEnd)) +
          ")"
        : ""
    }}
  </button>
</div>
}
